export default __webpack_public_path__ + "static/media/DieCasting.86305f6f.jpg";